module.exports = __webpack_public_path__ + "static/media/appointment.62ba6a85.svg";